import { type TFunction } from 'i18next'

import {
  type FiveSegment,
  fiveSegmentLabelI18nKeyMap,
  fiveSegments,
  wrapFiveSegmentLabelMapWithTranslate,
} from '~/utils'

export type OverlapColumnKey =
  FiveSegment | 'all' | 'brand1Name' | 'brand1Segments'

export const fiveSegmentsWithAll = ['all', ...fiveSegments] as const
export type FiveSegmentWithAll = (typeof fiveSegmentsWithAll)[number]

export const overlapKeyMap = {
  all: 'ALL',
  fiveSegment1: 'LOYAL',
  fiveSegment2: 'GENERAL',
  fiveSegment3: 'ESTRANGED',
  fiveSegment4: 'RECOGNIZED',
  fiveSegment5: 'UNRECOGNIZED',
} as const satisfies Record<FiveSegmentWithAll, string>
export type OverlapKey = ValueOf<typeof overlapKeyMap>

export const invertedOverlapKeyMap = {
  ALL: 'all',
  LOYAL: 'fiveSegment1',
  GENERAL: 'fiveSegment2',
  ESTRANGED: 'fiveSegment3',
  RECOGNIZED: 'fiveSegment4',
  UNRECOGNIZED: 'fiveSegment5',
} as const satisfies Record<OverlapKey, FiveSegmentWithAll>

// eslint-disable-next-line jsdoc/require-param, jsdoc/require-returns
/**
 * TODO: [i18n改善] t関数を引数で受け取る設計を見直す
 * 翻訳キーを返し、呼び出し側でt()を適用する形に変更することで、保守性の改善を行う
 */
export const createFiveSegmentWithAllLabelMap = (t: TFunction) => ({
  ...wrapFiveSegmentLabelMapWithTranslate(fiveSegmentLabelI18nKeyMap, t),
  all: t('total'),
})
